document.addEventListener('DOMContentLoaded', () => {

// ────────────────────────────────────────────────────────────────────────────
//  Configuration & State
// ────────────────────────────────────────────────────────────────────────────
const selectedVariants    = [];
const BUNDLE_MONEY_FORMAT = "{{ shop.money_with_currency_format }}";

const bundleList       = document.getElementById('bundle-list');
const itemCount        = document.getElementById('item-count');
const discountDisplay  = document.getElementById('bundle-discount');
const addToCartBtn     = document.getElementById('add-bundle-to-cart');
const resetBtn         = document.getElementById('reset-bundle');

// ────────────────────────────────────────────────────────────────────────────
//  Restore from localStorage
// ────────────────────────────────────────────────────────────────────────────
const saved = localStorage.getItem('namieBundle');
if (saved) {
  try {
    const arr = JSON.parse(saved);
    if (Array.isArray(arr) && arr.length) {
      selectedVariants.push(...arr);
      updateBundleSummary();

      const notice = document.createElement('div');
      notice.textContent = 'Your bundle was restored from a previous visit.';
      notice.style.cssText = [
        'background: #eaf7ea',
        'border: 1px solid #b2d8b2',
        'color: #2e7d32',
        'padding: 1rem',
        'border-radius: 8px',
        'margin-bottom: 1rem'
      ].join(';');
      document.querySelector('.bundle-summary')?.prepend(notice);
    }
  } catch (e) {
    console.warn('Failed to restore bundle:', e);
    localStorage.removeItem('namieBundle');
  }
}


// ────────────────────────────────────────────────────────────────────────────
//  Quantity Controls & Accordion
// ────────────────────────────────────────────────────────────────────────────

//  Product-card qty wiring
function bindQuantityControls(root = document) {
  root.querySelectorAll('.bundle-item').forEach(item => {
    const minusBtn = item.querySelector('.qty-btn.minus');
    const plusBtn  = item.querySelector('.qty-btn.plus');
    const input    = item.querySelector('.bundle-qty-input');
    if (!minusBtn || !plusBtn || !input) return;

    minusBtn.addEventListener('click', () => {
      const v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });

    plusBtn.addEventListener('click', () => {
      const v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  });
}
bindQuantityControls();

// Summary-list delegation (auto-remove when hitting zero)
bundleList.addEventListener('click', e => {
  const btn = e.target.closest('.qty-btn');
  if (!btn) return;

  const li = btn.closest('.bundle-summary-item');
  if (!li) return;

  const optionKey = decodeURIComponent(li.dataset.optionKey);
  const idx       = selectedVariants.findIndex(v => v.optionKey === optionKey);
  if (idx < 0) return;

  const entry = selectedVariants[idx];
  if (btn.classList.contains('minus')) {
    // Remove entry at 1, otherwise decrement
    entry.quantity > 1 ? entry.quantity-- : selectedVariants.splice(idx, 1);
  } else {
    entry.quantity++;
  }

  updateBundleSummary();
});

// Accordion toggle
document.querySelectorAll('.accordion-toggle').forEach(button => {
  button.addEventListener('click', () => {
    const panel = button.nextElementSibling;
    panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
  });
});


// ────────────────────────────────────────────────────────────────────────────
//  Add‐to‐Bundle Logic (with per‐variant options)
// ────────────────────────────────────────────────────────────────────────────
document.querySelectorAll('.add-to-bundle').forEach(button => {
  button.addEventListener('click', () => {
    const card = button.closest('.bundle-item');
    const qty  = Math.max(1, parseInt(card.querySelector('.bundle-qty-input').value, 10) || 1);

    const picker = card.querySelector('bundle-variant-picker');
    let variantId, price, options = '';

    if (picker && card._variantData) {
      try {
        const variantData = card._variantData;
        const selectors = picker.querySelectorAll('.option-selector');

        const selectedOptions = Array.from(selectors).map(sel => {
          const opt = sel.querySelector('.custom-select__option[aria-selected="true"]');
          return opt?.dataset.value || null;
        });

        if (selectedOptions.includes(null)) {
          alert('Please select all options before adding to bundle.');
          return;
        }

        const matched = variantData.find(v =>
          v.options.every((opt, i) => opt === selectedOptions[i])
        );

        if (matched) {
          variantId = matched.id;
          price     = matched.price / 100;
          options   = selectedOptions.join(' · ');
        } else {
          alert('Please select a valid combination of options.');
          return;
        }
      } catch (err) {
        console.error('Variant selection error:', err);
        alert('An error occurred while selecting a variant.');
        return;
      }
    }

    // fallback to the card’s data-attributes
    if (!variantId) {
      variantId = parseInt(card.dataset.variantId, 10);
      price     = parseFloat(card.dataset.price);
      options   = card.dataset.options || '';
    }

    const title     = card.querySelector('h3')?.innerText;
    const handle    = button.dataset.handle;
    const optionKey = `${variantId}|${options}`;

    const existing = selectedVariants.find(v => v.optionKey === optionKey);
    if (existing) {
      existing.quantity += qty;
    } else {
      selectedVariants.push({
        id:         variantId,
        optionKey:  optionKey,
        title:      title,
        handle:     handle,
        price:      price,
        options:    options,
        quantity:   qty
      });
    }

    updateBundleSummary();
  });
});


// ────────────────────────────────────────────────────────────────────────────
//  Bundle Summary / Discount Bar
// ────────────────────────────────────────────────────────────────────────────
function updateBundleSummary() {
  //  Clear old lines
  bundleList.innerHTML = '';

  //  Compute subtotal
  let subtotal = selectedVariants.reduce((sum, v) => sum + v.price * v.quantity, 0);

  //  Determine discount rate
  let rate = 0;
  if      (subtotal >= 200) rate = 0.20;
  else if (subtotal >= 150) rate = 0.15;
  else if (subtotal >= 100) rate = 0.10;
  else if (subtotal >=  50) rate = 0.05;

  //  Render each line item
  selectedVariants.forEach(item => {
    const discountedPrice = item.price * (1 - rate);
    const lineTotal       = discountedPrice * item.quantity;

    bundleList.insertAdjacentHTML('beforeend', `
      <li class="bundle-summary-item"
          data-variant-id="${item.id}"
          data-option-key="${encodeURIComponent(item.optionKey)}">
        <div class="bundle-summary-left">
          <div class="bundle-item-title">${item.title}</div>
          ${item.options 
            ? `<div class="bundle-item-options">${item.options}</div>` 
            : ''}
        </div>
        <div class="bundle-summary-controls">
          <div class="bundle-qty-control">
            <button class="qty-btn minus">−</button>
            <input type="number" 
                   class="bundle-qty-input" 
                   value="${item.quantity}" 
                   min="1">
            <button class="qty-btn plus">+</button>
          </div>
          <div class="bundle-item-price">
            <s>£${(item.price * item.quantity).toFixed(2)}</s>
            <strong>£${lineTotal.toFixed(2)}</strong>
          </div>
        </div>
      </li>
    `);
  });

  // Update summary labels
  const totalItems       = selectedVariants.reduce((sum, v) => sum + v.quantity, 0);
  const discountedTotal  = (subtotal * (1 - rate)).toFixed(2);
  itemCount.textContent  = `${totalItems} | £${discountedTotal}`;
  discountDisplay.textContent = `${Math.round(rate * 100)}%`;

  // Update desktop progress bar
  updateProgressBar(subtotal);

  // Re-bind quantity handlers on new rows
  bindQuantityControls(bundleList);

  // Persist and sync to mobile drawer
  localStorage.setItem('namieBundle', JSON.stringify(selectedVariants));
  syncMobileDrawer();
}

// Mobile drawer list qty handling
document
  .getElementById('mobile-bundle-content')
  .addEventListener('click', e => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;

    const li  = btn.closest('.bundle-summary-item');
    const key = decodeURIComponent(li.dataset.optionKey);
    const idx = selectedVariants.findIndex(v => v.optionKey === key);
    if (idx < 0) return;

    const entry = selectedVariants[idx];
    if (btn.classList.contains('minus')) {
      entry.quantity > 1 ? entry.quantity-- : selectedVariants.splice(idx,1);
    } else {
      entry.quantity++;
    }

    updateBundleSummary();
  });

/**
 * Drives progress bars:
 *  • Desktop (#progress-fill, .progress-marker.unlocked, #progress-label)
 *  • Mobile (#mobile-progress-fill)
 */
function updateProgressBar(subtotal) {
  const MAX = 200;
  const rawPct = Math.min((subtotal / MAX) * 100, 100);
  const safePct = isNaN(rawPct) ? '0%' : rawPct.toFixed(2) + '%';

  // Desktop
  const fillEl = document.getElementById('progress-fill');
  const labelEl = document.getElementById('progress-label');
  const markers = document.querySelectorAll('.progress-marker');

  if (fillEl && fillEl.style.width !== safePct) {
    fillEl.style.width = safePct;
  }

  markers.forEach(marker => {
    const threshold = parseInt(marker.dataset.discount, 10) * 10;
    marker.classList.toggle('unlocked', subtotal >= threshold);
  });

  const nextThresholds = [50, 100, 150, 200];
  const next = nextThresholds.find(t => subtotal < t);
  if (labelEl) {
    labelEl.textContent = next
      ? `Spend £${(next - subtotal).toFixed(2)} more to unlock ${next / 10}% off`
      : 'Max discount unlocked!';
  }

  // Mobile Sticky Bar
  const mobileFill = document.getElementById('mobile-progress-fill');
  if (mobileFill && mobileFill.style.width !== safePct) {
    mobileFill.style.width = safePct;
  }

  // Slide-up drawer progress bar
  const panelFill = document.querySelector('#mobile-bundle-panel .progress-fill');
  if (panelFill) {
    panelFill.classList.add('progress-fill');
    panelFill.style.transition = 'width 0.4s ease';
    panelFill.style.width = safePct; // ✅ This was missing
  }
}


// ────────────────────────────────────────────────────────────────────────────
// Variant Picker Fallback: Manual resolution via selects
// ────────────────────────────────────────────────────────────────────────────
document.querySelectorAll('.bundle-item').forEach(card => {
  const selects = card.querySelectorAll('select');
  if (!selects.length) return;

  const variants = JSON.parse(card.dataset.variants || '[]');
  const addBtn   = card.querySelector('.add-to-bundle');
  const priceEl  = card.querySelector('.bundle-price');
  const imgEl    = card.querySelector('img');

  function updateVariant() {
    const selectedOptions = Array.from(selects).map(s => s.value.trim());
    const match = variants.find(v =>
      JSON.stringify(v.options.map(o => o.trim())) === JSON.stringify(selectedOptions)
    );
    if (!match) return;

    // Sync data-attributes
    card.dataset.variantId = match.id;
    card.dataset.price     = match.price / 100;
    addBtn.dataset.variantId = match.id;
    addBtn.dataset.price     = match.price / 100;

    // Update UI price
    if (priceEl) {
      priceEl.textContent = `£${(match.price / 100).toFixed(2)}`;
    }

    // Update image
    if (match.featured_image?.src && imgEl) {
      imgEl.src = match.featured_image.src.replace(/(\.\w+)(?:\?.*)?$/, '_medium$1');
    }

    // Update options label
    card.dataset.options = selectedOptions.join(' · ');
  }

  selects.forEach(sel => sel.addEventListener('change', updateVariant));
  updateVariant(); // Initial sync
});


// ────────────────────────────────────────────────────────────────────────────
// Listen for 'bundle:variant:change' from <bundle-variant-picker>
// ────────────────────────────────────────────────────────────────────────────
document
  .querySelectorAll('bundle-variant-picker')
  .forEach(picker => {
    picker.addEventListener('bundle:variant:change', e => {
      const variant = e.detail.variant;
      const selectedOptions = e.detail.selectedOptions;
      if (!variant) return;

      const card   = picker.closest('.bundle-item');
      const priceEl = card.querySelector('.bundle-price');
      const imgEl   = card.querySelector('img');
      const addBtn  = card.querySelector('.add-to-bundle');

      // Update data attributes
      card.dataset.variantId = variant.id;
      card.dataset.price     = variant.price / 100;
      card.dataset.options   = selectedOptions.join(' · ');

      // Sync the add-to-bundle button
      if (addBtn) {
        addBtn.dataset.variantId = variant.id;
        addBtn.dataset.price     = variant.price / 100;
      }

      // Refresh the displayed price
      if (priceEl) {
        priceEl.textContent = `£${(variant.price / 100).toFixed(2)}`;
      }

      // Update the main image if provided
      if (variant.featured_image?.src && imgEl) {
        imgEl.src = variant.featured_image.src.replace(/(\.\w+)(?:\?.*)?$/, '_medium$1');
      }
    });
  });

// ────────────────────────────────────────────────────────────────────────────
// Mobile Drawer Logic
// ────────────────────────────────────────────────────────────────────────────
const mobileToggle   = document.getElementById('mobile-bundle-toggle');
const mobilePanel    = document.getElementById('mobile-bundle-panel');
const mobileClose    = document.getElementById('mobile-bundle-close');
const mobileContent  = document.getElementById('mobile-bundle-content');
const mobileTotal    = document.getElementById('mobile-bundle-total');
const toggleIcon     = document.getElementById('mobile-toggle-icon');

// Sync the drawer’s contents and total
function syncMobileDrawer() {
  if (typeof selectedVariants === 'undefined') return;

  const subtotal = selectedVariants.reduce((sum, v) => sum + v.price * v.quantity, 0);
  const rate     = subtotal >= 200 ? 0.2
                   : subtotal >= 150 ? 0.15
                   : subtotal >= 100 ? 0.1
                   : subtotal >=  50 ? 0.05
                   : 0;
  const total    = selectedVariants.reduce(
    (sum, v) => sum + v.price * v.quantity * (1 - rate),
    0
  );

  if (mobileTotal) {
    mobileTotal.textContent = `Bundle Summary £${total.toFixed(2)}`;
  }

  // Only update specific sections of content
  const desktopSummary = document.querySelector('.bundle-summary');
  const mobileList     = mobileContent.querySelector('#bundle-list');
  const desktopList    = desktopSummary?.querySelector('#bundle-list');

  if (mobileList && desktopList) {
    mobileList.innerHTML = desktopList.innerHTML;
    bindQuantityControls(mobileList);
  }

  // Update discount and totals
  const itemCountEl = mobileContent.querySelector('#item-count');
  const discountEl  = mobileContent.querySelector('#bundle-discount');
  if (itemCountEl) itemCountEl.textContent = `${selectedVariants.reduce((sum, v) => sum + v.quantity, 0)} | £${total.toFixed(2)}`;
  if (discountEl) discountEl.textContent = `${Math.round(rate * 100)}%`;

  // Update progress bar
  updateProgressBar(subtotal);
}

// Ensure the panel sits above the mobile bar
function adjustMobilePanelPadding() {
  const bar = document.getElementById('mobile-bundle-bar');
  if (mobilePanel && bar) {
    mobilePanel.style.paddingBottom = `${bar.offsetHeight + 16}px`;
  }
}

// Toggle drawer open/close
mobileToggle.addEventListener('click', () => {
  const isOpen = mobilePanel.classList.toggle('open');
  mobileToggle.setAttribute('aria-expanded', isOpen);

  if (toggleIcon) {
    toggleIcon.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
  }

  if (isOpen) {
    syncMobileDrawer();
    requestAnimationFrame(() => {
      mobilePanel.classList.add('open-visible');
      mobilePanel.hidden = false;
    });
  } else {
    mobilePanel.classList.remove('open-visible');
    mobilePanel.hidden = true;
  }
});

mobileClose.addEventListener('click', () => {
  mobilePanel.classList.remove('open', 'open-visible');
  mobilePanel.hidden = true;
  mobileToggle.setAttribute('aria-expanded', 'false');

  if (toggleIcon) {
    toggleIcon.style.transform = 'rotate(0deg)';
  }
});

window.addEventListener('resize', adjustMobilePanelPadding);
adjustMobilePanelPadding();

// Wait for variants to initialize, then sync once
const waitForVariants = setInterval(() => {
  if (Array.isArray(selectedVariants)) {
    syncMobileDrawer();
    clearInterval(waitForVariants);
  }
}, 100);


// ────────────────────────────────────────────────────────────────────────────
// Persist on unload
// ────────────────────────────────────────────────────────────────────────────
window.addEventListener('beforeunload', () => {
  localStorage.setItem('namieBundle', JSON.stringify(selectedVariants));
});


// ────────────────────────────────────────────────────────────────────────────
// Add Bundle to Cart (AJAX)
// ────────────────────────────────────────────────────────────────────────────
document.body.addEventListener('click', async e => {
  const btn = e.target.closest('.add-bundle-to-cart');
  if (!btn) return;

  if (selectedVariants.length === 0) {
    alert('Please add at least one item to your bundle.');
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Adding…';

  const items = selectedVariants.map(item => ({
    id: item.id,
    quantity: item.quantity
  }));

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!res.ok) throw new Error('Cart add failed');

    selectedVariants.length = 0;
    localStorage.removeItem('namieBundle');
    updateBundleSummary();
    window.location.href = '/cart';
  } catch (err) {
    console.error('Add to cart error:', err);
    alert('Something went wrong adding to the cart.');
  } finally {
    btn.disabled = false;
    btn.textContent = 'Add Bundle to Cart';
  }
});


// ────────────────────────────────────────────────────────────────────────────
// Auto-open first accordion on desktop only
// ────────────────────────────────────────────────────────────────────────────
function openFirstAccordionIfDesktop() {
  if (window.innerWidth >= 768) {
    const firstToggle = document.querySelector('.accordion-toggle');
    const firstPanel  = firstToggle?.nextElementSibling;
    if (firstPanel && firstPanel.style.display !== 'block') {
      firstPanel.style.display = 'block';
    }
  }
}

// run on load
openFirstAccordionIfDesktop();

// ────────────────────────────────────────────────────────────────────────────
// Reset Bundle Button
// ────────────────────────────────────────────────────────────────────────────
document.body.addEventListener('click', e => {
  const resetBtn = e.target.closest('#reset-bundle');
  if (!resetBtn) return;

  selectedVariants.length = 0;
  localStorage.removeItem('namieBundle');
  updateBundleSummary();
});


}); // end DOMContentLoaded
